export const ArrowIcon = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.07446 1.65763L10.2628 5.84592L1.10811 5.84041C0.900293 5.84041 0.700986 5.92296 0.554036 6.06991C0.407086 6.21686 0.324531 6.41617 0.324531 6.62399C0.324531 6.8318 0.407086 7.03111 0.554036 7.17806C0.700985 7.32501 0.900292 7.40757 1.10811 7.40757L10.2628 7.40205L6.07446 11.5903C5.92811 11.7367 5.84589 11.9352 5.84589 12.1422C5.84589 12.3491 5.92811 12.5476 6.07446 12.694C6.22082 12.8403 6.41931 12.9225 6.62628 12.9225C6.83325 12.9225 7.03175 12.8403 7.1781 12.694L12.6963 7.1758C12.7675 7.10282 12.8237 7.01658 12.8618 6.92197C12.9407 6.73113 12.9407 6.51683 12.8618 6.326C12.8237 6.23139 12.7675 6.14515 12.6963 6.07217L7.1781 0.553998C7.03175 0.407648 6.83325 0.325427 6.62628 0.325427C6.41931 0.325427 6.22081 0.407648 6.07446 0.553998C5.92811 0.700349 5.84589 0.898844 5.84589 1.10582C5.84589 1.31279 5.92811 1.51128 6.07446 1.65763Z"
      fill="#444444"
    />
  </svg>
)
